export default __webpack_public_path__ + "static/media/834.f3ecd641.png";